module.exports = __webpack_public_path__ + "15722f38bcc0308d4d0aac6c87e0f51d.jpg";